import { WidgetXcomponent } from '../../xcomponent/dist/widget-xcomponent-loader.min'
import { widgetUrl, inAdminWidgetPage, widgetIdInPath } from '../../utilities'
import { addEventListener, toggle } from '../../utilities/dom'
import moment from 'moment-timezone';
import listUl from './list-ul.svg';
import './index.css';

export default class Index {
  constructor(options) {
    this.options = {...options, externalId: null}
  }

  render() {
    const containers = document.getElementsByClassName('bta-upcoming-event-widget-container')

    this.appendPopupDom()

    Array.from(containers).forEach(container => {
      if (container.dataset.mode === 'popup') {
        this.popup(container)
      }

      const widget_id  = container.dataset.id || (inAdminWidgetPage() ? widgetIdInPath() : null),
            mode       = container.dataset.mode,
            xComponent = WidgetXcomponent.init({
              data: {
                mode
              },
              customUrl: widgetUrl(this.options, {
                start: moment().add(15, 'minute').format('YYYY-MM-DDTHH:mm'),
                finish: moment().add(5, 'month').format('YYYY-MM-DDTHH:mm'),
                profile: 'upcoming_event',
                mode,
                widget_id
              }),
              onInit: this.options.onInit,
              onSize(width) {
                if (container.dataset.mode === 'popup') {
                  xComponent.resize(width)
                }
              },
              onTrigger(data) {
                location.replace(data)
              },
            }, 'iframe', container)

      xComponent.render(container)
    })
  }

  appendPopupDom() {
    if (this.options.shopConfig &&
        this.options.shopConfig.widgets_mode &&
        this.options.shopConfig.widgets_mode.upcoming_event &&
        this.options.shopConfig.widgets_mode.upcoming_event.includes('popup')) {
      const div = document.createElement('div')
      div.classList.add('bta-upcoming-event-widget-container')
      div.classList.add('bta-fade-hide')
      div.classList.add('bta-popup')
      div.dataset.mode = 'popup'
      document.body.appendChild(div)
    }
  }

  popup(container) {
    const div = document.createElement('div')
    div.id = 'bta-upcoming-event-icon'

    div.innerHTML =
      `<div id="bta-upcoming-event-svg" class="bta-center">${listUl}</div>
       <div id="bta-widget-close" class="bta-fade-hide bta-center">&times;</div>`

    document.body.appendChild(div)

    const icon  = document.getElementById('bta-upcoming-event-icon'),
          svg   = icon.querySelector('#bta-upcoming-event-svg'),
          close = icon.querySelector('#bta-widget-close')

    icon.appendChild(container)

    addEventListener([icon], 'click', () => {
      toggle([close, container], 'bta-fade-hide')
      toggle(svg, 'bta-fade-hide')
      toggle(icon, 'bta-active')
    })
  }
}
